import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class AdminSubscriptions {
	async getSubscriptions(query: {
		status?: string;
		expires?: {
			from?: Date;
			to?: Date;
		};
		business_id?: string;
		orderBy?: string;
		limit?: number;
		page?: number;
	}) {
		return xget<PGSchema.subscriptions[]>("/admin/subscriptions", query);
	}

	async createSubscription(subscriptionData: Partial<PGSchema.subscriptions>) {
		return xhttp<PGSchema.subscriptions>("/admin/subscriptions", "POST", subscriptionData);
	}

	async getSubscription(id: string) {
		return xget<PGSchema.subscriptions>(`/admin/subscriptions/${id}`);
	}

	async updateSubscription(id: string, subscriptionData: Partial<PGSchema.subscriptions>) {
		return xhttp<PGSchema.subscriptions>(`/admin/subscriptions/${id}`, "PUT", subscriptionData);
	}

	async deleteSubscription(id: string) {
		return xhttp<Partial<PGSchema.subscriptions>>(`/admin/subscriptions/${id}`, "DELETE", {
			id
		});
	}
}
